export const COLLABORATION_ROLES = {
  COLLAB_MANAGER: 2,
  COLLAB_ADMIN: 1
};
